var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.13167 0.712087C8.76556 0.345971 8.17196 0.345971 7.80585 0.712087C7.43973 1.0782 7.43973 1.6718 7.80585 2.03791L11.8308 6.06291H1.90646C1.3887 6.06291 0.968964 6.48264 0.968964 7.00041C0.968964 7.51817 1.3887 7.93791 1.90646 7.93791H11.83L7.80585 11.9621C7.43973 12.3282 7.43973 12.9218 7.80585 13.2879C8.17196 13.654 8.76556 13.654 9.13167 13.2879L14.7567 7.66291C15.1228 7.29679 15.1228 6.7032 14.7567 6.33708L9.13167 0.712087Z"}));
}

ArrowInline.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
